import { s } from "../../../utilities/common"

export const WifiIcon = () => {
  return (
    <svg
      width={s("148")}
      height={s("148")}
      viewBox="0 0 148 148"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.4"
        d="M110.367 81.9968L115.845 75.6409C106.003 66.6195 94.1115 61.4938 81.8097 59.8536L110.367 81.9968ZM132.042 58.6234L138.808 51.6524C112.769 27.8689 76.6839 21.1029 44.9043 31.1494L54.5407 38.5304C81.3996 32.3795 110.514 39.1455 132.042 58.6234ZM9.02405 51.6524L15.79 58.6234C18.4554 56.368 21.1208 54.1127 23.9912 52.2674L15.9951 45.9115C13.5347 47.7568 11.2794 49.6021 9.02405 51.6524ZM31.9874 75.6409L38.7534 82.8169C38.7534 82.8169 47.1596 76.256 51.8753 74.0006L43.4691 67.4397C39.3685 69.695 31.9874 75.6409 31.9874 75.6409ZM57.6161 101.885C57.6161 111.111 64.7922 118.287 74.0186 118.287C82.4248 118.287 89.1908 111.931 90.2159 103.935L68.0727 86.7125C61.9218 88.9678 57.6161 94.9137 57.6161 101.885ZM74.0186 95.3237C77.5041 95.3237 80.5795 98.3992 80.5795 101.885C80.5795 105.575 77.5041 108.446 74.0186 108.446C70.328 108.446 67.4576 105.575 67.4576 101.885C67.4576 98.3992 70.328 95.3237 74.0186 95.3237Z"
        fill="white"
      />
      <rect
        opacity="0.8"
        x="17.0769"
        y="21.5833"
        width="140.634"
        height="9.86869"
        transform="rotate(37.8932 17.0769 21.5833)"
        fill="white"
      />
    </svg>
  )
}
